import { AccessControlService } from '~/app-modules/auth/services/access-control-service';
import { PermissionType } from '~/app-modules/user-access-right/clients/enums/permission-type';

export function isPermissionsSatisfy(permissions: PermissionType[]) {
  return useIOC(AccessControlService).isPermissionsSatisfy(permissions);
}
